import type { ApiBody, ApiQuery } from '../../../shared/api/contracts'
import { apiRequest, apiGet } from './transport'

export function fetchLimitsSummary(params: ApiQuery<'GET /admin/limits/summary'>, signal?: AbortSignal) {
  return apiRequest<'GET /admin/limits/summary'>(`/admin/limits/summary?${new URLSearchParams(params)}`, { signal })
}

export async function fetchBudgets(month?: string, signal?: AbortSignal) {
  const u = new URLSearchParams()
  if (month) u.set('month', month)
  return apiGet<'GET /admin/budgets'>(`/admin/budgets?${u.toString()}`, signal)
}

export async function createBudget(payload: ApiBody<'POST /admin/budgets'>, signal?: AbortSignal) {
  return apiRequest<'POST /admin/budgets'>('/admin/budgets', { method: 'POST', body: payload, signal })
}

export async function updateBudget(id: string, payload: ApiBody<'PUT /admin/budgets/:id'>, signal?: AbortSignal) {
  return apiRequest<'PUT /admin/budgets/:id'>(`/admin/budgets/${encodeURIComponent(id)}`, { method: 'PUT', body: payload, signal })
}

export async function deleteBudget(id: string, signal?: AbortSignal) {
  return apiRequest<'DELETE /admin/budgets/:id'>(`/admin/budgets/${encodeURIComponent(id)}`, { method: 'DELETE', signal })
}
